import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export default function Imprint() {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen pt-20 bg-white dark:bg-slate-900">
      {/* Hero Section */}
      <section className="relative py-16 md:py-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-emerald-50/20 dark:from-slate-900 dark:via-slate-900 dark:to-emerald-950/10" />
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#e2e8f0_1px,transparent_1px),linear-gradient(to_bottom,#e2e8f0_1px,transparent_1px)] dark:bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_0%,#000_70%,transparent_110%)]" />
        
        <div className="relative max-w-4xl mx-auto px-6 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-slate-600 dark:text-slate-400 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors duration-200 mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm font-medium">{t.imprintPage.backToHome}</span>
          </Link>
          
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white tracking-tight mb-4">
            {t.imprintPage.title}
          </h1>
          <p className="text-lg text-slate-600 dark:text-slate-400">
            {t.imprintPage.subtitle}
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <div className="space-y-12">
            {/* Company Information */}
            <div>
              <div className="space-y-1 text-slate-700 dark:text-slate-300 leading-relaxed">
                <p className="font-semibold text-lg text-slate-900 dark:text-white">Avalon X Media GmbH</p>
                <p>Schozacherstr. 40</p>
                <p>70437 Stuttgart</p>
                <p>Germany</p>
              </div>
            </div>

            <div className="h-px bg-slate-200 dark:bg-slate-800" />

            {/* Management */}
            <div>
              <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-4">
                {t.imprintPage.managingDirector}
              </h3>
              <p className="text-slate-700 dark:text-slate-300">
                Mr. Denys Tarasenko
              </p>
            </div>

            <div className="h-px bg-slate-200 dark:bg-slate-800" />

            {/* Commercial Register */}
            <div>
              <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-4">
                {t.imprintPage.commercialRegister}
              </h3>
              <div className="space-y-2 text-slate-700 dark:text-slate-300">
                <p><span className="text-slate-500 dark:text-slate-500">{t.imprintPage.courtOfRegistration}:</span> Stuttgart</p>
                <p><span className="text-slate-500 dark:text-slate-500">{t.imprintPage.registrationNumber}:</span> HRB800227</p>
              </div>
            </div>

            <div className="h-px bg-slate-200 dark:bg-slate-800" />

            {/* VAT ID */}
            <div>
              <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-4">
                {t.imprintPage.vatId}
              </h3>
              <p className="text-slate-700 dark:text-slate-300">
                DE455830727
              </p>
            </div>

            <div className="h-px bg-slate-200 dark:bg-slate-800" />

            {/* Contact */}
            <div>
              <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-4">
                {t.imprintPage.contactTitle}
              </h3>
              <div className="space-y-2 text-slate-700 dark:text-slate-300">
                <p>
                  <span className="text-slate-500 dark:text-slate-500">{t.contactPage.email}:</span>{' '}
                  <a 
                    href="mailto:service@avalonxmedia.com" 
                    className="text-emerald-600 dark:text-emerald-400 hover:underline"
                  >
                    service@avalonxmedia.com
                  </a>
                </p>
                <p>
                  <span className="text-slate-500 dark:text-slate-500">{t.contactPage.phone}:</span>{' '}
                  <a 
                    href="tel:+491723541325" 
                    className="text-emerald-600 dark:text-emerald-400 hover:underline"
                  >
                    +49 172 3541 325
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Back to Home Link */}
          <div className="mt-16 pt-8 border-t border-slate-200 dark:border-slate-800">
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 text-emerald-600 dark:text-emerald-400 hover:text-emerald-700 dark:hover:text-emerald-300 transition-colors duration-200 font-medium"
            >
              <ArrowLeft className="w-4 h-4" />
              {t.imprintPage.backToHome}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
